import { api } from './api';

export interface AiConfigData {
  _id?: string;
  name: string;
  unitId?: any;
  provider: 'gemini' | 'openai' | 'claude' | 'ollama';
  modelName: string;
  apiKey: string;
  temperature?: number;
  autoClassification?: boolean;
  autoExtraction?: boolean;
  isDefault?: boolean;
  promptClassification?: string;
  promptExtraction?: string;
  createdAt?: string;
}

export const aiService = {
  classify: async (documentId: string, unitId?: string, autoApply = true) => {
    const response = await api.post(`/ai/classify/${documentId}`, { unitId, autoApply });
    return response.data;
  },

  extract: async (documentId: string, documentTypeId?: string, unitId?: string, autoApply = true) => {
    const response = await api.post(`/ai/extract/${documentId}`, { documentTypeId, unitId, autoApply });
    return response.data;
  },

  process: async (documentId: string, unitId?: string) => {
    const response = await api.post(`/ai/process/${documentId}`, { unitId });
    return response.data;
  },

  chat: async (
    documentId: string,
    message: string,
    history: Array<{ role: 'user' | 'model'; text: string }> = [],
    unitId?: string,
  ) => {
    const response = await api.post(`/ai/chat/${documentId}`, { message, history, unitId });
    return response.data;
  },

  batchProcess: async (params: {
    documentIds?: string[];
    folderId?: string;
    unitId?: string;
    classify?: boolean;
    extract?: boolean;
  }) => {
    const response = await api.post('/ai/batch', params);
    return response.data;
  },

  getConfigs: async () => {
    const response = await api.get('/ai/config');
    return response.data;
  },

  getConfigById: async (id: string) => {
    const response = await api.get(`/ai/config/${id}`);
    return response.data;
  },

  saveConfig: async (data: Partial<AiConfigData>, id?: string) => {
    if (id) {
      const response = await api.put(`/ai/config/${id}`, data);
      return response.data;
    }
    const response = await api.post('/ai/config', data);
    return response.data;
  },

  deleteConfig: async (id: string) => {
    const response = await api.delete(`/ai/config/${id}`);
    return response.data;
  },

  testConnection: async (params: { apiKey: string; modelName?: string; provider?: string }) => {
    const response = await api.post('/ai/test-connection', params);
    return response.data;
  },
};
